import { addDays, subtractDays } from '@/utils/date'

export default {
  props: {
    from: {
      type: Object,
      default () {
        return {
          name: 'starting_date',
          label: '_arrival_date'
        }
      }
    },
    to: {
      type: Object,
      default () {
        return {
          name: 'ending_date',
          label: '_departure_date'
        }
      }
    },
    value: {
      type: Object,
      default: function () {
        return {
          from: null,
          to: null
        }
      }
    }
  },
  methods: {
    fromDateChanged (fromDate) {
      this.value.from = fromDate

      if (this.canLastTheDay) {
        this.$refs.to.setMinDate(fromDate)
      } else {
        this.$refs.to.setMinDate(addDays(fromDate, 1))
      }
 
      if (this.value.to <= this.value.from) {
        this.$refs.to.setDate(addDays(fromDate, 1))
      }

      this.emitValues()
    },
    toDateChanged (toDate) {
      this.value.to = toDate

      if (this.value.to <= this.value.from) {
        this.$refs.to.setDate(addDays(this.value.to, 1))
      }
      
      if (this.value.to !== null && this.value.from === null) {
        this.$refs.from.setDate(subtractDays(toDate, 1))
      }

      this.emitValues()
    },
    emitValues () {
      this.$emit('input', this.value)
    }
  }
}
